var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#004529",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8363 28.4138C58.2401 28.8181 58.4669 29.3661 58.4669 29.9376C58.4669 30.509 58.2401 31.057 57.8363 31.4613L37.7113 51.5863C37.307 51.9901 36.759 52.2169 36.1876 52.2169C35.6162 52.2169 35.0681 51.9901 34.6638 51.5863L23.1638 40.0863C22.952 39.8889 22.7821 39.6509 22.6642 39.3864C22.5464 39.1219 22.483 38.8363 22.4779 38.5468C22.4728 38.2573 22.526 37.9697 22.6345 37.7012C22.7429 37.4327 22.9043 37.1888 23.1091 36.9841C23.3138 36.7793 23.5577 36.6179 23.8262 36.5095C24.0947 36.401 24.3823 36.3477 24.6718 36.3529C24.9613 36.358 25.2469 36.4213 25.5114 36.5392C25.7759 36.657 26.0139 36.827 26.2113 37.0388L36.1876 47.0151L54.7888 28.4138C55.1931 28.01 55.7412 27.7832 56.3126 27.7832C56.884 27.7832 57.432 28.01 57.8363 28.4138Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.2d01e611c9f5e0c6e0045acdc5582815.svg";
export { ForwardRef as ReactComponent };